import _ from 'lodash';
import { RESPONSE_ASSET } from '../actions/constantsActions';

const initialState = {
  metadata: {}
};

export default function asset(state = initialState, action) {
  if (action.type === RESPONSE_ASSET) {
    return action.asset;
  }
  return state;
}

export const getAssets = state => _.get(state, 'asset');
